const getBaseUrl = () => {
  const basename = process.env.REACT_APP_BASENAME || "/esafe";
  return window.location.origin + basename;
};

export default getBaseUrl;
